module.exports = __webpack_public_path__ + "img/search-dark.1048044b.svg";